import React, { useState } from 'react';
import { useProductBrain } from '../../contexts/ProductBrainContext';
import { saveOnboarding } from '../../services/productBrain';
import { PRODUCT_CONTEXTS, PRODUCT_STAGES, productContext } from '../../lib/productContext';

export default function ProductContextForm() {
  const { workspace, refresh } = useProductBrain();
  const [form, setForm] = useState(() => productContext(workspace));
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const change = (key, value) => { setForm(current => ({ ...current, [key]: value })); setMessage(''); };
  const selected = PRODUCT_CONTEXTS[form.kind];
  const save = async e => {
    e.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      const { kind, stage, navigation, audience_detail, desired_outcome } = form;
      await saveOnboarding({ product_context: { kind, stage, navigation, audience_detail: audience_detail.trim(), desired_outcome: desired_outcome.trim() } });
      await refresh(); setMessage('Product context saved. You can change it anytime.');
    } catch (err) { setError(err.message || 'Could not save product context.'); }
    finally { setBusy(false); }
  };
  return <section className="v2-panel" aria-label="Your product context">
    <h2>Make SPCC fit your product</h2>
    <p>Start with the people you serve and the outcome you want. Sources and AI are optional.</p>
    <form onSubmit={save}>
      <fieldset disabled={busy} className="product-context-fields">
        <div className="v2-form-grid">
          <label className="v2-field"><span>Product context</span><select value={form.kind} onChange={e => change('kind', e.target.value)}>{Object.entries(PRODUCT_CONTEXTS).map(([key, value]) => <option key={key} value={key}>{value.label}</option>)}</select></label>
          <label className="v2-field"><span>Product stage</span><select value={form.stage} onChange={e => change('stage', e.target.value)}>{Object.entries(PRODUCT_STAGES).map(([key, label]) => <option key={key} value={key}>{label}</option>)}</select></label>
          <label className="v2-field"><span>Who do you serve?</span><input maxLength={500} value={form.audience_detail} placeholder={selected.audience} onChange={e => change('audience_detail', e.target.value)}/></label>
          <label className="v2-field"><span>What outcome matters now?</span><input maxLength={1000} value={form.desired_outcome} placeholder={`For example: improve ${selected.metrics[0].toLowerCase()}`} onChange={e => change('desired_outcome', e.target.value)}/></label>
          <label className="v2-field"><span>Workspace navigation</span><select value={form.navigation} onChange={e => change('navigation', e.target.value)}><option value="focused">Focused: daily decisions and learning</option><option value="full">Full: show every workflow</option></select></label>
        </div>
        <p className="v2-muted">Useful evidence: {selected.sources}. Metric examples: {selected.metrics.join(', ')}.</p>
        <button className="v2-button" type="submit">{busy ? 'Saving…' : 'Save product context'}</button>
      </fieldset>
      {error && <p role="alert" className="v2-error">{error}</p>}
      {message && <p role="status">{message}</p>}
    </form>
  </section>;
}
